import classNames from 'classnames';
import { FC, ReactElement } from 'react';

import { IconNames } from '../MaterialIcon/MaterialIcon';
import styles from './IconButton.module.scss';

interface IconButtonProps {
  className?: string;
  icon: IconNames | ReactElement;
  onClick?: () => void;
}

const IconButton: FC<IconButtonProps> = ({ icon, className, onClick }) => {
  return (
    <button className={classNames(styles.button, className)} onClick={onClick}>
      {typeof icon === 'string' ? (
        <i aria-hidden="true" className={classNames('material-icons')}>{icon}</i>
      ) : (
        icon
      )}
    </button>
  );
};

export default IconButton;
